import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['military-service-national-guard-title']),
    nationalGuardActivated: yesNoUI({
      title: content['military-service-national-guard-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['nationalGuardActivated'],
    properties: {
      nationalGuardActivated: yesNoSchema,
    },
  },
};
